/**
 * Data-load status of the current server render (VIP-12038).
 *
 * A render whose loader could not fill the store still produces valid markup —
 * the page's own skeleton — and would otherwise be indistinguishable from a
 * healthy one: same 200, same shell, cacheable for as long as the CDN likes.
 * Loaders report the failure here and `entry-server` turns it into
 * `RenderResult.dataLoadFailed`, so the HTTP layer can answer `no-store` (or a
 * 500) instead of pinning an empty page in front of every visitor.
 *
 * A sink rather than a stored flag, for the same reason the request resolvers
 * in SiteConfig/MetaHelper/RequestHelper are: concurrent renders must not see
 * each other's state, so the server entry routes it into its own
 * AsyncLocalStorage context.
 */

type FailureSink = (reason?: unknown) => void

let _sink: FailureSink | null = null

/** Installed by the server entry; resets with `null` (tests). */
export const setSsrDataFailureSink = (sink: FailureSink | null): void => {
  _sink = sink
}

/**
 * Report that this render could not load the data its page needs. No-op in the
 * browser and outside a render, so loaders can call it unconditionally.
 */
export const reportSsrDataLoadFailure = (reason?: unknown): void => {
  _sink?.(reason)
}
